import { Outlet, Link, NavLink } from "react-router-dom";
import { useStorefrontRefreshSse } from "../hooks/useStorefrontRefreshSse";
import { useAuth } from "../contexts/AuthContext";
import { useTenant } from "../contexts/TenantContext";

export function RootLayout() {
  useStorefrontRefreshSse();
  const { isAuthed, user, logout } = useAuth();
  const { meta } = useTenant();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl flex items-center justify-between px-4 py-3">
          <Link to="/" className="font-bold tracking-tight" data-testid="site-logo">
            Showcase {meta?.tenant.display_name ? `· ${meta.tenant.display_name}` : ""}
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <NavLink to="/" className="hover:underline" end>
              Catalogus
            </NavLink>
            {isAuthed ? (
              <>
                <NavLink to="/account" className="hover:underline">
                  {user?.name ?? user?.email ?? "Account"}
                </NavLink>
                <button
                  type="button"
                  onClick={() => void logout()}
                  className="rounded border border-gray-300 px-3 py-1 hover:bg-gray-100"
                >
                  Uitloggen
                </button>
              </>
            ) : (
              <NavLink
                to="/login"
                className="rounded border border-gray-300 px-3 py-1 hover:bg-gray-100"
              >
                Inloggen
              </NavLink>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-4 text-xs text-gray-500">
          Wireframe-implementatie · Storefront v2 · {new Date().getFullYear()}
        </div>
      </footer>
    </div>
  );
}
